export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "winner-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "winner-themeWrap" */'./ThemeImporter'),
  },
};
